export default __webpack_public_path__ + "static/media/error.89056cf2.jpg";